export default "__VITE_ASSET__UjE1JcDq__"